<template>
  <li class="nav-item">
    <router-link
      v-if="isInternalRoute"
      :to="link.path"
      @click.native="linkClick"
      class="nav-link"
      :title="link.name"
    >
      <template>
        <i :class="link.icon"></i>
        <span class="nav-link-text">{{ link.name }}</span>
      </template>
    </router-link>
    <a
      v-else
      :href="link.path"
      class="nav-link"
      target="_blank"
      rel="noopener"
      :title="link.name"
    >
      <i :class="link.icon"></i>
      <span class="nav-link-text">{{ link.name }}</span>
    </a>
  </li>
</template>
<script>
export default {
  name: "sidebar-item",
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: [],
        };
      },
      description:
        "Sidebar link. Can contain name, path, icon and other attributes.",
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  computed: {
    isInternalRoute() {
      return (
        typeof this.link.path === "string" && this.link.path.startsWith("/")
      );
    },
  },
  data() {
    return {
      children: [],
      collapsed: true,
    };
  },
  methods: {
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
